import { ReadonlyRefNum } from '@/components/shared/EditableRefNum'
import type { RefNumsByType } from '@/utils/shipmentFuncs'

type Props = {
  refNumsByType: RefNumsByType
}

export const RefNumCarrierInfo = ({ refNumsByType }: Props) => {
  const carrierName = refNumsByType['carrier-name']
  const dotNum = refNumsByType['dot-num']

  if (!carrierName && !dotNum) return null
  return (
    <div className="flex flex-col gap-y-2">
      {carrierName && <span>Carrier: {carrierName}</span>}
      {dotNum && <ReadonlyRefNum label="DOT#" value={dotNum} />}
    </div>
  )
}
